import { EventCardModel, SectionModel } from '@flocasts/experience-service-types'
import { notNullOrUndefined } from 'src/app/shared/functions/type-guards'

export const mapLiveEventMetadataToPossibleGeoBlockedIds = (section: SectionModel<EventCardModel>) => {
  const liveEventIds = section.items.map(item => item.liveEventMetadata?.liveEventId).filter(notNullOrUndefined)
  return liveEventIds.length > 0 ? liveEventIds : []
}
